import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const MajorTurnOffStyles = styled(OnboardingPage)`
  ion-content {
    --padding-top: 20px;
    --padding-bottom: 20px;

    &::part(scroll) {
      overflow: auto;
    }
  }
`;
